import API_URLS from "../helper/api-urls";
import ApiHelper from "../helper/api-helper";

const insertUpdateSubpoenaRequest = (payload) => {
  return ApiHelper.postRequest(API_URLS.INSERT_UPDATE_SUBPOENA_REQUEST, payload);
};

const getSubpoenaRequests = (payload) => {
  return ApiHelper.postRequest(API_URLS.GET_SUBPOENA_REQUEST, payload);
};

const getSubpoenaRequestById = (subpoenaRequestId, regionId) => {
  return ApiHelper.getRequest(
    `${API_URLS.GET_SUBPOENA_REQUEST_BY_ID}?subpoenaRequestId=${subpoenaRequestId}&regionId=${regionId}`
  );
};

const updateSubpoenaRequestStatus = (payload) => {
  return ApiHelper.putRequest(
    API_URLS.UPDATE_SUBPOENA_REQUEST_STATUS,
    payload
  );
};

const deleteSubpoenaRequest = (payload) => {
  return ApiHelper.deleteRequest(API_URLS.DELETE_SUBPOENA_REQUEST, payload);
};

const getSubpoenaModules = (regionId) => {
  return ApiHelper.getRequest(`${API_URLS.GET_SUBPOENA_MODULES}?regionId=${regionId}`);
};

const sendSubpoenaLinkEmail = (subpoenaRequestId, regionId) => {
  return ApiHelper.getRequest(`${API_URLS.SEND_SUBPOENA_LINK_EMAIL}?subpoenaRequestId=${subpoenaRequestId}&regionId=${regionId}`);
};

const getSubpoenaRequestZipUrl = (payload) => {
  return ApiHelper.postRequest(API_URLS.GET_SUBPOENA_REQUEST_ZIP_URL, payload);
};

export const SubpoenaRequestService = {
  insertUpdateSubpoenaRequest,
  getSubpoenaRequests,
  getSubpoenaRequestById,
  updateSubpoenaRequestStatus,
  deleteSubpoenaRequest,
  getSubpoenaModules,
  sendSubpoenaLinkEmail,
  getSubpoenaRequestZipUrl,
};

